import React from 'react';
import {
  Gift,
  Inbox,
  UserList,
  FileText,
  Book,
  Briefcase,
  PaperPlane,
  MailCheck,
  Flame,
  Gear,
  Search,
  Dots,
  Checkbox,
  ChartBar,
  Mail,
  EmailVerifier,
  MailChart,
  Wallet,
  WorldMarker,
  World,
  Viewfinder,
} from '@saleshandy/icons';
import { KanbanViewIcon } from '../../../../../shared/svg/kanban-view';
import { ListViewIcon } from '../../../../../shared/svg/list-view';

export const getNavItemIcon = (eventKey: string) => {
  if (eventKey === 'referral') {
    return <Gift height={24} width={24} />;
  }
  if (eventKey === 'sequence') {
    return <PaperPlane height={24} width={24} />;
  }
  if (eventKey === 'tasks') {
    return <Checkbox width={24} height={24} />;
  }
  if (eventKey === 'agency-client') {
    return <Briefcase height={24} width={24} />;
  }
  if (eventKey === 'unifiedInbox') {
    return <Inbox height={24} width={24} />;
  }
  if (eventKey === 'prospects') {
    return <UserList height={24} width={24} />;
  }
  if (eventKey === 'list') {
    return <ListViewIcon height={24} width={24} />;
  }
  if (eventKey === 'kanban') {
    return <KanbanViewIcon height={24} width={24} />;
  }
  if (eventKey === 'email-accounts') {
    return <Mail height={24} width={24} />;
  }
  if (eventKey === 'email-insights') {
    return <MailCheck height={24} width={24} />;
  }
  if (eventKey === 'warmup') {
    return <Flame height={24} width={24} />;
  }
  if (eventKey === 'templates') {
    return <FileText height={24} width={24} />;
  }
  if (eventKey === 'inbox-radar') {
    return <MailChart height={24} width={24} />;
  }
  if (eventKey === 'reports') {
    return <ChartBar height={24} width={24} />;
  }
  if (eventKey === 'growthHub') {
    return <Book height={24} width={24} />;
  }
  if (eventKey === 'agencyPortal') {
    return <Briefcase height={24} width={24} />;
  }
  if (eventKey === 'setting') {
    return <Gear height={24} width={24} />;
  }
  if (eventKey === 'cold-email-masterclass') {
    return <Gift height={24} width={24} />;
  }
  if (eventKey === 'leads') {
    return <Search height={24} width={24} />;
  }
  if (eventKey === 'v2-leads') {
    return <Viewfinder height={24} width={24} />;
  }
  if (eventKey === 'more') {
    return <Dots height={24} width={24} />;
  }
  if (eventKey === 'Refer') {
    return <Gift height={24} width={24} />;
  }
  if (eventKey === 'email-verifier') {
    return <EmailVerifier height={24} width={24} />;
  }
  if (eventKey === 'billing') {
    return <Wallet height={24} width={24} />;
  }
  if (eventKey === 'domains') {
    return <World height={24} width={24} />;
  }
  if (eventKey === 'inframail-ips') {
    return <WorldMarker height={24} width={24} />;
  }
  return <></>;
};
